var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [(_vm.reversedDecodedEmail)?_c('a',{attrs:{"href":hover ? _vm.href : null}},[_vm._v("\n    "+_vm._s(_vm.reversedDomain)),_c('span',[_vm._v("x")]),_vm._v("@"),_c('span',[_vm._v("y")]),_vm._v(_vm._s(_vm.reversedAccount)+"\n  ")]):_c('span')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }